/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Content_LabelInputs */

const en_settings_tickets_content_label = /** @type {(inputs: Settings_Tickets_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_settings_tickets_content_label = /** @type {(inputs: Settings_Tickets_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题描述`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Settings_Tickets_Content_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_content_label = /** @type {((inputs?: Settings_Tickets_Content_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Content_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_content_label(inputs)
	return zh_settings_tickets_content_label(inputs)
});
export { settings_tickets_content_label as "settings.tickets.content_label" }